// File: src/pages/ChakraTest.js
import React from "react";
import {
Box,
Button,
VStack,
useToast,
Heading,
Text,
} from "@chakra-ui/react";

function ChakraTest() {
const toast = useToast();

return (
<VStack spacing={6} p={6}>
<Heading size="lg">🌿 Chakra UI Test</Heading>

<Box p={4} bg="teal.50" borderRadius="md" boxShadow="sm">
<Text fontSize="md">
Click the buttons below to test different Chakra styles and feedback
</Text>
</Box>

<Button
colorScheme="teal"
onClick={() => toast({ title: "Success", status: "success" })}
>
✅ Primary (Success Toast)
</Button>

<Button
colorScheme="red"
onClick={() => toast({ title: "Error", status: "error" })}
>
❌ Danger (Error Toast)
</Button>

<Button
colorScheme="yellow"
onClick={() => toast({ title: "Caution", status: "warning" })}
>
⚠️ Warning Toast
</Button>

<Button
colorScheme="purple"
onClick={() => toast({ title: "Info", status: "info" })}
>
💬 Info Toast
</Button>
</VStack>
);
}

export default ChakraTest;